import { makeStyles } from '@material-ui/core/styles';
export const useStyles = makeStyles(theme => ({
  root: {
    color: 'white',
    padding: 25,
  },
  container: {
    background: theme.colors.dark.darkBlue,
    borderRadius: 16,
  },
  item: {
    border: `1px solid rgba(255,255,255,.3)`,
    borderRadius: 10,
    marginTop: 10,
    '&.MuiListItem-gutters': {
      paddingRight: 0,
    },
  },
  itemsContainer: {
    padding: 20,
    marginLeft: '30%',
    width: '50%',
    position: 'fixed',
    color: 'white',
  },
}));
